import { render } from "./LandingPageGTop.vue?vue&type=template&id=f003cb90&scoped=true&ts=true"
import script from "./LandingPageGTop.vue?vue&type=script&lang=ts"
export * from "./LandingPageGTop.vue?vue&type=script&lang=ts"

import "./LandingPageGTop.vue?vue&type=style&index=0&id=f003cb90&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f003cb90"]])

export default __exports__